import Vue from 'vue'
import App from './App'
// store
import store from '@/store/index'
// 模拟数据
// import '@/mock'
import permission from '@/directive/permission/index.js' // 权限判断指令
//全局组件
import '@/components'

//echarts
import echarts from 'echarts'
import 'echarts/map/js/china'
Vue.prototype.$echarts=echarts

// 多国语
import i18n from './i18n'

// 全局方法
import '@/libs/date'
import '@/libs/mixins'

// 全局指令
import '@/libs/directives'

//打印
import Print from '@/plugin/print/print'
import Print1 from '@/plugin/print/print1'
//导入excle
import XLSX from 'xlsx'

//charts
import VCharts from 'v-charts'

//element-ui
import element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/style/MHel.scss'
// import '@/assets/fonts/iconfont.css'
import 'v-charts/lib/style.css'

// 全局过滤器
import '@/libs/modules'

// 菜单和路由设置
import router from './router'
import menuData from './menu/modules/menu'

// 请求
import axios from '@/plugin/axios'
import newAxios from '@/plugin/newAxios'
import {uploadRequest,uploadRequest2} from '@/api/request'
import uploadPost from '@/assets/axios-upload'

//全局变量
import Global from "./plugin/Global";
import helper from "./helper"

//des加密
import des from './plugin/des'

//图片滑块验证
import SlideVerify from 'vue-monoplasty-slide-verify';

Vue.use(SlideVerify);

//动画
import CollapseTransition from 'element-ui/lib/transitions/collapse-transition';
//办理限制弹框
import blxzDla from '@/components/blxz/blxzDla';
//金钱转换
import Convert from '@/plugin/convertCurrency/convert'
Vue.use(Convert)

//加密解密
Vue.prototype.$des = des
Vue.prototype.DESKEY = process.env.VUE_APP_DESKEY

//事件总线
Vue.prototype.$eventBus = new Vue();

// 使用公共方法
Vue.use(helper)
Vue.use(element)
Vue.use(VCharts)
Vue.use(XLSX)
Vue.use(Print)
Vue.use(Print1)
Vue.use(SlideVerify);
Vue.use(permission)

// 发送请求
Vue.prototype.$axios = axios
Vue.prototype.$newAxios = newAxios
Vue.prototype.$upload = uploadPost
Vue.prototype.$uploads =uploadRequest
Vue.prototype.$newUploads =uploadRequest2

//动画组件
Vue.component(CollapseTransition.name, CollapseTransition)
Vue.component(blxzDla.name,blxzDla);
//煤炭类别
Vue.prototype.GLOBAL = Global


//电子签章地址  http://111.33.90.27:8081
Vue.prototype.CONTRACT_URL = process.env.VUE_APP_PIC_CONTRACT_URL
//图片访问前缀
Vue.prototype.PIC_URL_PRE = process.env.VUE_APP_PIC_URL_PRE
//用户手册地址
Vue.prototype.DOCUMENTURL= process.env.VUE_APP_DOCUMENTURL
//货物追踪
Vue.prototype.Goods_URL=process.env.VUE_APP_Goods_URL
//地图访问地址
Vue.prototype.Base_Railway_LineUrl=process.env.VUE_APP_Base_Railway_LineUrl
Vue.prototype.Station_Url=process.env.VUE_APP_Station_Url
Vue.prototype.Newline_Url=process.env.VUE_APP_Newline_Url

//图片加载出错时显示占位图路径
Vue.prototype.defaultImg = 'this.src="' + require('./layouts/images/loaderror.svg') + '"'
//图片未上传时显示占位图路径npm
Vue.prototype.unuploadImg = 'this.src="' + require('./layouts/images/uploaderror.svg') + '"'
import lodash from 'lodash'
import {detectZoom} from "@/libs/detectZoom";
Vue.prototype.$lodash = lodash

//访问内部系统主页的路径
Vue.prototype.InSystem_Url=process.env.VUE_APP_InSystem_Url

//访问预警决策系统主页的路径
Vue.prototype.DecisionSystem_Url=process.env.VUE_APP_DecisionSystem_Url
// import enLocale from 'element-ui/lib/locale/lang/en'
// import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
Vue.use(element, {
  i18n: (key, value) => i18n.t(key, value)
});


window.vm = new Vue({
  store,
  i18n,
  router,
  render: h => h(App),
  created() {
    let arr = menuData.List
    if(window.sessionStorage.getItem("userId")){
      arr  = JSON.parse(window.sessionStorage.getItem("initMenu"))
    }
    let arr1 = []
    Object.assign(arr1,arr)
    arr1.forEach((item,index)=>{
      if(item.path == '/settings'){
        arr1.splice(index,1)
      }
    })
    this.$store.commit('d2admin/menu/headerSet',arr1)
    this.$store.dispatch('d2admin/menu/loadMenu').then(menu => {
      if (menu) {
        this.$store.commit('d2admin/menu/headerSet', menu)
        this.$store.commit('d2admin/search/init', menu)
      }
    })
  },
  mounted() {
      console.log(localStorage.getItem('lang'))
      let lang = localStorage.getItem('lang')
      if(lang=="es"){
         import('@/assets/fonts/iconfont.css')
      }else{
        import('@/assets/fonts/iconfont1.css')
      }
  },
  watch: {
    // 监听路由 控制侧边栏显示
    '$route.matched'(val) {
      const menuTree = this.$store.state.d2admin.menu.header
      const _side = menuTree.filter(menu => menu.path === val[0].path)
      this.$store.commit('d2admin/menu/asideSet', _side.length > 0 ? _side[0].children : [])
    }
  }
}).$mount('#app')
// let app = new Vue({
//   router,
//   store,
//   i18n,
//   render: h => h(App),
//
// }).$mount('#app')
export default window.vm;
